import { KeyOutlinedIcon } from '@/components';
import type { TagBaseModel } from '@/features/tag/models';
import type { FC } from 'react';
import type { z } from 'zod';

type Props = {
  scope: z.infer<typeof TagBaseModel.shape.scope>;
};

export const TagIcon: FC<Props> = ({ scope }) => {
  switch (scope) {
    case 'local':
      return <KeyOutlinedIcon />;
    case 'global':
      return null;
    default: {
      return null;
    }
  }
};
